<script lang="ts">
import ClubBanner from '@/components/banners/ClubBanner.vue'
import PartnerBanner from '@/components/banners/PartnerBanner.vue'
import QuickLinksCard from '@/components/cards/QuickLinksCard.vue'
import BannerLayoutProvider from '@/components/sections/Banner/BannerLayoutProvider.vue'
import HomeSection from '@/components/sections/HomeSection.vue'
import LatestWinnersSection from '@/components/sections/LatestWinnersSection.vue'
import ProductOverviewSection from '@/components/sections/ProductOverviewSection.vue'
import FaqView from '@/views/faq/FaqView.vue'
import { defineComponent } from 'vue'

/**
 * The "Home" brand page - this is temporary until we find a better pattern
 */
export default defineComponent({
  components: {
    BannerLayoutProvider,
    FaqView,
    HomeSection,
    ProductOverviewSection,
    QuickLinksCard,
    LatestWinnersSection,
    ClubBanner,
    PartnerBanner,
  },
})
</script>

<template>
  <BannerLayoutProvider />

  <QuickLinksCard />

  <LatestWinnersSection />

  <ClubBanner />

  <HomeSection />

  <ProductOverviewSection id="product-overview-section" />

  <PlansSection />

  <PartnerBanner />

  <FaqView :show-breadcrumb="false" />
</template>
